var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.NH=require("moment");module.exports=$CLJS.NH;